import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    DialogTitle,
    LinearProgress,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import styles from './QAPhotoUploadDialogMenuItem.styles';
import classnames from 'classnames';
import { AppContext } from '../../../../../AppContext';
import { OrderReviewContext, UPDATE_IMAGES } from '../../../OrderReviewContext';

// SERVICES
import { cloneDeep } from 'lodash';
import { Text } from '../../../../FormFields';
import { RetrieveHoverPhotos } from '../../../../../services';

const RetrieveHoverPhotosDialog = ({ classes, onClose, open }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [hoverJobId, setHoverJobId] = useState(null);

    const { dispatch } = useContext(AppContext);
    const {
        state: { orderLineId, formHeaders },
    } = useContext(OrderReviewContext);

    console.log({orderLineId})
    const changeHoverJobId = (e) => {
        setHoverJobId(e.target.value)
    }

    const retrivePhotosFromHoverJob = async () => {
        try {
            setIsSubmitting(true);
            await RetrieveHoverPhotos(orderLineId, hoverJobId);
            window.location.reload();
        }
        catch (error) {
            alert('Error retrieving hover photos');
            setIsSubmitting(false);
        }
        setIsSubmitting(false);
    }

    const handleRetrievePhotos = async () => {
        if (!hoverJobId) {
            dispatch({
                type: 'SET_SNACKBAR',
                snackbar: {
                    isOpen: true,
                    variant: 'error',
                    message: 'Hover Job Id is Required',
                },
            });
        } else {
            await retrivePhotosFromHoverJob();
            window.location.reload();
        }
    }


    return (
        <React.Fragment>
            <Dialog
                open={open}
                fullWidth={true}
                maxWidth="lg"
                onClose={onClose}
                aria-labelledby="image-modal-title"
                className={classes.qaPhotoUploadDialog}
                autoScrollBodyContent={false}
                contentStyle={{ width: '100%', maxWidth: 'none' }}
            >
                <DialogTitle>Retrieve Hover Job Photos</DialogTitle>
                <DialogContent>
                    <main className={classnames('col-center-center', classes.container)}>
                        <Text disabled={true} label="Hover Job Id" value={hoverJobId} onChange={changeHoverJobId} />
                    </main>
                </DialogContent>
                <DialogActions
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    }}
                >
                    <Button
                        disabled={isSubmitting}
                        onClick={onClose}
                        variant="contained"
                        style={{ backgroundColor: '#315382', color: 'white' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={isSubmitting}
                        
                        onClick={handleRetrievePhotos}
                        variant="contained"
                        style={{ backgroundColor: '#315382', color: 'white' }}
                    >
                        {isSubmitting ? "Retrieving Photos..." : "Retrieve Hover Photos"}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

RetrieveHoverPhotosDialog.defaultProps = {};
RetrieveHoverPhotosDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
};

export default withStyles(styles)(RetrieveHoverPhotosDialog);
